import { type Permission } from '@webapp/models'
import { type PermissionEnum } from '@webapp/platform/iam'

export const hasPermission = (
  permissions: Permission[],
  permission: PermissionEnum
) => {
  return permissions.map((perm) => perm.codename).includes(permission)
}

export const hasNoPermissions = (permissions: Permission[]) => {
  return permissions.length === 0
}
